import Pusher from 'pusher-js';

let pusher = null;
let channel = null;

/**
 * @param {string|number} userId
 * @param {function} onNotification
 */
export function connectPusher(userId, onNotification = () => {}) {
  if (pusher) return;

  let token = localStorage.getItem('Administrativo_tk');

  if (!token) {
    console.warn('Token JWT não encontrado');
    return;
  }

  token = token.replace(/^"+|"+$/g, '');

  pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    forceTLS: true,
    authEndpoint: `${process.env.REACT_APP_API_URL}/api/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    },
  });

  const channelName = `private-user.${userId}`;

  channel = pusher.subscribe(channelName);

  channel.bind('pusher:subscription_error', (err) => {
    console.error('❌ Erro ao inscrever no canal', err);
  });

  channel.bind(
    'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
    onNotification
  );

  channel.bind('user.notification', onNotification);
}

export function disconnectPusher() {
  if (!pusher) return;

  if (channel) {
    pusher.unsubscribe(channel.name);
    channel = null;
  }

  pusher.disconnect();
  pusher = null;
}
